import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class RemessaService {
  constructor(
    private http: HttpClient
  ) { }

  obterRemessas(contaId) {
    return this.http
      .get(urls.apiBase + '/Remessas/ObterTodos?contaId=' + contaId);
  }

  obterBoletosPorRemessaId(id) {
    return this.http
      .get(urls.apiBase + '/Remessas/obterBoletosPorRemessaId?remessaId=' + id);
  }

  gerarRemessa(contaId, cedenteId) {
    return this.http
      .get(urls.apiBase + '/Remessas/GerarRemessa?contaId=' + contaId + '&cedenteId=' + cedenteId);
  }

  obterQtdBoletoSemRemessas(contaId) {
    return this.http
      .get(urls.apiBase + '/Remessas/obterQtdBoletoSemRemessas?contaId=' + contaId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/remessa/remessa.service.ts